module.exports = __webpack_public_path__ + "img/fuwu3.33687dc8.jpg";